import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link, Image, Text, Heading3, ButtonLink } from '@blueprint/ui';

export const PropertyNewsWrapper = styled.div(
    ({ theme: { spacing, colors, mq } }) =>
        css`
            width: 100%;
            height: auto;
            background-color: ${colors.white};
            margin-top: ${spacing['24px']};
            justify-content: center;
            align-items: center;
            padding: 0 ${spacing['16px']};

            ${mq.medium} {
                padding: 0;
            }
        `
);

export const MainImageContainer = styled.div(
    ({ theme: { mq, spacing, borderRadius } }) =>
        css`
            width: 100%;
            height: 100%;
            display: block;
            border-radius: ${borderRadius['8px']};
            padding: ${spacing['16px']} 0 0 0;
            img {
                border-radius: ${borderRadius['8px']};
                object-fit: cover;
                height: 100%;
            }
            ${mq.medium} {
                width: 55%;
                height: 100%;
                padding: ${spacing['16px']} ${spacing['16px']} 0 0;
            }
        `
);

export const ArticleLarge = styled('article')(
    ({ theme: { mq, colors } }) =>
        css`
            display: block;
            width: 100%;
            ${Link} {
                color: ${colors['grey-slate']};
            }

            ${mq.medium} {
                display: flex;
            }
        `
);

export const ImageContainer = styled.div(
    ({ theme: { spacing, mq, borderRadius } }) =>
        css`
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: row;
            border-radius: ${borderRadius['8px']};
            padding-bottom: ${spacing['16px']};
            img {
                border-radius: ${borderRadius['8px']};
                object-fit: cover;
                height: 100%;
                width: 100%;
            }

            ${mq.medium} {
                img {
                    border-radius: ${borderRadius['8px']};
                    object-fit: cover;
                    height: 100%;
                    width: 100%;
                }
            }
        `
);

export const ArticleSmall = styled('article')(
    ({ theme: { spacing, colors, mq } }) =>
        css`
            display: block;
            width: 100%;
            padding: ${spacing['32px']} 0;
            ${Link} {
                color: ${colors['grey-slate']};
            }
            ${mq.medium} {
                &:last-child {
                    padding-left: ${spacing['24px']};
                }
                &:first-child {
                    padding-right: ${spacing['24px']};
                }
            }
        `
);

export const ArticleWrapper = styled.div(
    ({ theme: { mq } }) =>
        css`
            display: block;
            width: 100%;

            ${mq.medium} {
                display: flex;
            }
        `
);

export const StyledHeading = styled(Heading3)(
    ({ theme: { spacing } }) => css`
        padding-top: ${spacing['8px']};
        width: 100%;
    `
);

export const StyledImage = styled(Image)(
    () =>
        css`
            width: 100%;
            height: 100%;
        `
);

export const MainImageHeading = styled(Heading3)(
    ({ theme: { spacing } }) => css`
        padding: ${spacing['8px']} 0 ${spacing['16px']} 0;
    `
);

export const MainArticleInfoWrapper = styled.div(
    ({ theme: { spacing, mq } }) => css`
        padding: ${spacing['16px']} ${spacing['16px']} 0 0;
        width: 100%;

        ${mq.medium} {
            width: 45%;
        }
    `
);

export const MainArticleSnippet = styled(Text)(
    ({ theme: { mq } }) => css`
        display: none;

        ${mq.medium} {
            display: block;
        }
    `
);

export const StyledButton = styled(ButtonLink)(
    ({ theme: { mq } }) => css`
        display: none;

        ${mq.medium} {
            display: block;
        }
    `
);

export const StyledButtonMobile = styled(ButtonLink)(
    ({ theme: { mq } }) => css`
        display: block;

        ${mq.medium} {
            display: none;
        }
    `
);

export const MainText = styled(Text)(
    ({ theme: { mq, spacing } }) => css`
        padding: ${spacing['8px']} 0 ${spacing['16px']} 0;

        ${mq.medium} {
            display: block;
        }
    `
);

export const HeadingWrapper = styled.div(
    ({ theme: { mq } }) => css`
        display: block;

        ${mq.medium} {
            display: flex;
            justify-content: space-between;
        }
    `
);
